import { render, staticRenderFns } from "./InsightsSummary.vue?vue&type=template&id=13a18125&scoped=true"
import script from "./InsightsSummary.vue?vue&type=script&lang=js"
export * from "./InsightsSummary.vue?vue&type=script&lang=js"
import style0 from "./InsightsSummary.vue?vue&type=style&index=0&id=13a18125&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a18125",
  null
  
)

export default component.exports